import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b77673f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-product-data-4w ba-column-title ba-text ba-text-right"
};
const _hoisted_2 = {
  class: "ba-double-content"
};
const _hoisted_3 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_target_icon = _resolveComponent("target-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.mode === 'acos' ? (_openBlock(), _createBlock(_component_percentage_value, {
    key: 0,
    value: $props.acos4W
  }, null, 8, ["value"])) : _createCommentVNode("", true), $props.mode === 'roas' ? (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $props.roas4W,
    showSymbol: false,
    precision: 1
  }, null, 8, ["value"])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "ba-double-content-inner",
    id: $props.item_id
  }, [_createVNode(_component_target_icon, {
    height: 10,
    width: 10,
    color: "#93999F"
  }), $props.mode === 'acos' ? (_openBlock(), _createBlock(_component_percentage_value, {
    key: 0,
    value: $props.cap
  }, null, 8, ["value"])) : _createCommentVNode("", true), $props.mode === 'roas' ? (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $props.cap,
    showSymbol: false,
    precision: 1
  }, null, 8, ["value"])) : _createCommentVNode("", true)], 8, _hoisted_3), _ctx.$slots['popover_content'] ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 2,
    target: $props.item_id,
    "auto-width": "",
    placement: "left"
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "popover_content", {}, undefined, true)]),
    _: 3
  }, 8, ["target"])) : _createCommentVNode("", true)])]);
}